<template>
    <el-popover trigger="hover" :placement="placement" :width="width">
        <slot />
        <slot name="reference">
            <svg-icon
                slot="reference"
                icon-class="question-circle"
                style="color: #409eff;"
                :style="{
                    fontSize: fontSize
                }" />
        </slot>
    </el-popover>
</template>

<script>
export default {
    name: 'DsQuestion',
    props: {
        placement: {
            type: String,
            default: 'bottom-start'
        },
        fontSize: {
            type: Number,
            default: 14
        },
        width: {
            type: [Number, String],
            default: null
        }
    }
};
</script>
